import React from 'react';
import {
  FigmaButton,
  type FigmaButtonProps,
  type FigmaButtonVariant,
} from 'components/UI/FigmaButton';
import {
  Button as Button_DEPRECATED,
  type Button as ButtonDeprecatedProps,
} from './Button_DEPRECATED';

// List of variants supported by FigmaButton
const FIGMA_VARIANTS: FigmaButtonVariant[] = [
  'default-primary',
  'destructive-primary',
  'default-secondary',
  'destructive-secondary',
  'default-tertiary',
  'destructive-tertiary',
  'default-quaternary',
  'destructive-quaternary',
  'default-link',
  'destructive-link',
];

// HybridButton props: allow all props from both button types
export type HybridButtonProps = FigmaButtonProps | ButtonDeprecatedProps;

export const Button = React.forwardRef<HTMLButtonElement, HybridButtonProps>(
  (props, ref) => {
    const { variant = 'default-primary', ...rest } = props;
    // If the variant is supported by FigmaButton, use it
    if (FIGMA_VARIANTS.includes(variant as FigmaButtonVariant)) {
      return (
        <FigmaButton
          ref={ref as any}
          variant={variant as FigmaButtonVariant}
          {...rest}
        />
      );
    }
    // Otherwise, fall back to Button_DEPRECATED
    return (
      <Button_DEPRECATED ref={ref as any} variant={variant as any} {...rest} />
    );
  },
);

Button.displayName = 'Button';
